/**
 * 상세 화면(주문·견적·결제) 라벨-값 목록 모양 — 두 칸 격자(라벨 회색·값 기본색).
 * 섹션마다 같은 클래스를 써서 모든 카드의 목록이 같은 모양이 되게 한다.
 */
export const detailListStyles = {
  list: 'grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm wrap-anywhere',
  term: 'text-muted-foreground',
  /** 값이 비었을 때(미정·미결제 등)의 흐린 글자. */
  empty: 'text-muted-foreground',
  /** 카드 안 작은 소제목(h3). */
  subheading: 'text-sm font-semibold',
} as const;
